import { School, Country } from "app/shared/model";
import { DiscountListItemDto } from "app/shared/model/DiscountListItemDto";
import { Agent } from "app/shared/model/Agent";
import { ProductStatusFilterValue } from "app/shared/components/productStatusFilterUtils";

export enum ActionType {
    PageLoaded = 'DiscountsList/PageLoaded',
    ChangeSearchTerm = 'DiscountsList/ChangeSearchTerm',
    ChangeStatusFilter = 'DiscountsList/ChangeStatusFilter',
    ChangeTypeFilter = 'DiscountsList/ChangeTypeFilter',
    ChangeSchoolFilter = 'DiscountsList/ChangeSchoolFilter',
    ChangeSortOrder = 'DiscountsList/ChangeSortOrder',
    ResetFilters = 'DiscountsList/ResetFilters',
    Other = '__OTHER__'
}

export type PageLoadedEvent = {
    type: ActionType.PageLoaded
    discounts: DiscountListItemDto[]
    data: PageLoadedData
}

export type PageLoadedData = {
    schools: School[],
    countries: Country[], 
    agents: Agent[]
}

export type ChangeSearchTerm = {
    type: ActionType.ChangeSearchTerm,
    searchTerm: string
}

export type ChangeStatusFilter = {
    type: ActionType.ChangeStatusFilter,
    statusFilter: ProductStatusFilterValue
}

export type ChangeTypeFilter = {
    type: ActionType.ChangeTypeFilter,
    types: string[]
}

export type ChangeSchoolFilter = {
    type: ActionType.ChangeSchoolFilter,
    schoolIds: string[]
}

export type ChangeSortOrder = {
    type: ActionType.ChangeSortOrder,
    sortOrder: string
}

export type ResetFilters = {
    type: ActionType.ResetFilters
}

export type OtherAction = {
    type: ActionType.Other
}

export type Action =
    | PageLoadedEvent
    | ChangeSearchTerm
    | ChangeStatusFilter
    | ChangeTypeFilter
    | ChangeSchoolFilter
    | ChangeSortOrder
    | ResetFilters
    | OtherAction